import React, { useState, useEffect } from "react";
import { useAuth } from "../../../Context/AuthContext";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Tooltip from "@mui/material/Tooltip";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeadNavtabs from "./LeadNavtabs";
import { DataGrid } from "@mui/x-data-grid";
import Interactionmodal from "../Interactionmodal";
const LeadInteraction = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const leadId = location.state?.leadId;
  const roleId = sessionStorage.getItem("roleId");
  const userId = sessionStorage.getItem("userId");
  // const token = sessionStorage.getItem("token");
  const apiUrl = process.env.REACT_APP_API_REST_URL;

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
    getValues,
  } = useForm({ mode: "onTouched" });
  const [annualincometypes, setannualincometypes] = useState([]);
  const [locationTypes, setlocationTypes] = useState([]);
  const [engagementTypes, setEngagementTypes] = useState([]);
  const [leadData, setLeadData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [opendelete, setOpendelete] = useState(false);
  const [selectedIddelete, setSelectedIddelete] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  // Handle menu navigation
  const from = location.state?.from || "/employeedashboard/leads";
  const handleMenuClick = (action) => {
    switch (action) {
      case "profile":
        navigate("/employeedashboard/leads/edit", { state: { leadId, from } });
        break;
      case "interactions":
        break;
      case "add-interaction":
        navigate("/employeedashboard/leads/add-interaction", {
          state: { leadId, from },
        });
        break;
      case "kyc":
        navigate("/employeedashboard/leads/kyc", {
          state: { leadId, from },
        });
        break;
      case "documents":
        // Navigate to documents
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    const fetchLeadData = async () => {
      if (!leadId) {
        setIsLoading(false);
        setError("No lead ID provided");
        return;
      }

      try {
        setIsLoading(true);
        const response = await axios.get(
          `${apiUrl}/CCE/api/v1/referalEngine/getReferralById/${leadId}`
        );
        setLeadData(response.data);
      } catch (err) {
        console.error("Error fetching lead data:", err);
        setError("Failed to load lead data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchLeadData();
  }, [leadId, apiUrl]);
  const interactions = leadData?.interactionDetails || [];
  const intId = interactions[0]?.id;
  const latestInteraction = interactions.reduce(
    (latest, current) =>
      new Date(current.created_date) > new Date(latest.created_date)
        ? current
        : latest,
    interactions[0]
  );
  const cancelHandler = () => {
    navigate("/employeedashboard/leads/view", { state: { leadId, from } });
  };
  const formatDateString = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB");
    } else {
      return "N/A";
    }
  };
  const getAnnualincomeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/estimated_annual_income`;
      const response = await axios.get(url, {});
      console.log("waelthndata", response);
      setannualincometypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getLocationtypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/location_type`;
      const response = await axios.get(url, {
        // Include any data that needs to be sent in the request body here
      });
      console.log("locationdata", response);
      setlocationTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getEngagementtypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/engagement_type`;
      const response = await axios.get(url, {});
      // console.log("engagementdata", response);
      setEngagementTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getAnnualincomeData();
    getLocationtypeData();
    getEngagementtypeData();
  }, []);
  const handleOpenModal = (interactionId) => {
    const selectedInteraction = leadData?.interactionDetails?.find(
      (item) => item.id === interactionId
    );
    setSelectedData(selectedInteraction);
    console.log("clkes inside modal");
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setSelectedData(null);
    setOpenModal(false);
  };
  const handleDeleteClickdelete = (id) => {
    setSelectedIddelete(id);
    console.log("selectid of delete", id);
    setOpendelete(true);
  };

  const handleClosedelete = () => {
    setOpendelete(false);
    setSelectedIddelete(null);
  };
  const handleConfirmDelete = async () => {
    const headers = {
      "x-access-token": token,
    };
    try {
      const response = await axios.delete(
        `${apiUrl}/CCE/api/v1/referalEngine/deleteReferralInteraction/${selectedIddelete}`,
        { headers }
      );
      // console.log("response of delete", response);
      if (response.status === 200) {
        // Handle successful deletion (e.g., refresh data)
        toast.success("Interaction deleted successfully");
        setLeadData((prevData) => {
          if (!prevData) return prevData;

          const updatedInteractions = prevData.interactionDetails.filter(
            (interaction) => interaction.id !== selectedIddelete
          );

          return {
            ...prevData,
            interactionDetails: updatedInteractions,
          };
        });
      } else {
        // Handle error
        toast.failure("Failed to delete");
      }
    } catch (error) {
      // Handle error
      toast.failure("An error occurred");
    } finally {
      handleClosedelete();
    }
    // setModalOpen(false);

    // setOpendelete(false);
  };
  const Columns = [
    {
      field: "meeting_at",
      headerName: "Meeting Date",
      // valueFormatter: (params) => formatDateString(params.value),
      renderCell: (params) => {
        const interactionId = params.row.id;
        return (
          <div>
            <div
              title={`${params.value}`}
              onClick={() => handleOpenModal(interactionId)}
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              {formatDateString(params.value)}
            </div>
          </div>
        );
      },
      width: 150,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "location_type_engagement_type",
      headerName: "Location",
      width: 200,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      renderCell: (params) => {
        const locationType = params.row.location_type_description || "";
        const engagementType = params.row.engagement_type_description || "";
        const locationTypeDesc = params.row.location|| "";

        return (
          <div
            title={`${engagementType} ${locationType && `, ${locationType}`} ${locationTypeDesc && `, ${locationTypeDesc}`}`}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "145px",
            }}
          >
            {engagementType}
            {locationType && `, ${locationType}`}
            {locationTypeDesc && `, ${locationTypeDesc}`}
          </div>
        );
      },
    },
    {
      field: "status_desc",
      headerName: "Status",
      width: 150,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "lead_status_desc",
      headerName: "Lead Status",
      width: 170,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },

    {
      field: "expected_date_of_closure",
      headerName: "Exp.Dt.Closure",
      valueFormatter: (params) => formatDateString(params.value),
      width: 170,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "estimated_annual_income",
      headerName: "Est.Annual Income",
      width: 170,
      headerAlign: "center",
      cellClassName: "centerAlign",
      renderCell: (params) => (
        <div>
          {
            annualincometypes.find((item) => item.id === params.value)
              ?.masterValueDesc
          }
        </div>
      ),
    },
    {
      field: "followup_date_n_time",
      headerName: "Follow Up Date",
      valueFormatter: (params) => formatDateString(params.value),
      width: 150,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    ...(roleId === "1" || roleId === "6"
      ? [
          {
            field: "action",
            headerName: "Action",
            width: 100,
            headerClassName: "boldHeader",
            cellClassName: "centerAlign",
            headerAlign: "center",
            renderCell: (params) => (
              <Tooltip title="Delete">
                <DeleteIcon
                  color="error"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDeleteClickdelete(intId)}
                />
              </Tooltip>
            ),
          },
        ]
      : []),
  ];
  return (
    <>
      <Box sx={styles.main_container}>
        {/* <ToastContainer
        position="bottom-right"
        autoClose={3000}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        toastStyle={{ textAlign: "left" }}
        theme="colored"
      /> */}

        <Paper sx={styles.dashboard_paper}>
          <LeadNavtabs
            handleMenuClick={handleMenuClick}
            options={[
              {
                label: "Edit Profile",
                onClick: () => handleMenuClick("profile"),
              },
              {
                label: "View Interactions",
                onClick: () => handleMenuClick("interactions"),
              },
              {
                label: "Add Interaction",
                onClick: () => handleMenuClick("add-interaction"),
              },
              { label: "View KYC", onClick: () => handleMenuClick("kyc") },
              {
                label: "Upload Documents",
                onClick: () => handleMenuClick("documents"),
                disabled: true,
              },
            ]}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              p: 1,
              justifyContent: "flex-end",
              width: "50%",
              marginLeft: "auto",
            }}
          >
            <Button sx={styles.btn} variant="contained" onClick={cancelHandler}>
              Back
            </Button>
          </Box>
        </Paper>

        <Paper
          elevation={3}
          sx={{
            margin: "10px 20px 20px 20px",
            height: "590px",
            borderRadius: "12px",
          }}
        >
          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <div style={{ height: 524, width: "100%", overflow: "auto" }}>
              {interactions.length > 0 ? (
                <>
                  <DataGrid
                    // loading={loading}
                    rows={interactions}
                    getRowId={(row) => row.id}
                    columns={Columns}
                    pageSize={5}
                    rowsPerPageOptions={[5, 10, 20]}
                    // sx={sxStyles.boldHeader}
                    sx={{
                      ...sxStyles.boldHeader, // Spread existing styles
                      fontSize: "13px",
                      "& .MuiDataGrid-columnHeaders": {
                        fontWeight: "bold",
                        textAlign: "center",
                      },
                      "& .MuiDataGrid-cell": {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                  />
                  <Dialog open={opendelete} onClose={handleClosedelete}>
                    <DialogTitle>
                      {"Are you sure you want to delete this interaction?"}
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        This action cannot be undone.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleClosedelete} color="primary">
                        No
                      </Button>
                      <Button
                        onClick={handleConfirmDelete}
                        color="primary"
                        autoFocus
                      >
                        Yes
                      </Button>
                    </DialogActions>
                  </Dialog>
                </>
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    fontSize: "16px",
                    color: "gray",
                  }}
                >
                  No interaction for this lead.
                </div>
              )}
            </div>
          )}
        </Paper>
      </Box>
      <Interactionmodal
        open={openModal}
        onClose={handleCloseModal}
        selectedData={selectedData}
        onStatusUpdate={(status) => {
          console.log("Status updated:", status);
        }}
        interactionType="lead"
      />
    </>
  );
};

export default LeadInteraction;
const sxStyles = {
  boldHeader: {
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
};
const styles = {
  main_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "90vh",
    padding: "0px",
    margin: "0px",
    marginTop: "-25px",
    background: "#f2f2f2",
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    margin: "0px 20px",
  },
  btn: {
    width: "80px",
    fontSize: "11px",
    marginTop: "3px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfield: {
    width: "340px",
  },
};
